import Ember from 'ember';
export function initialize() {
  Ember.libraries.register('Ember Model Validator', '4.4.0');
}
export default {
  initialize
};